/**
 * Accordion
 * ======================================
 * - slideup slidedown animation via css height transition
 */

 const ELEMENTS = ".js-Accordion .js-Accordion-header";
 const TOGGLE_CLASS = "is-open";

 class Accordion {
   constructor() {
     this.elements = document.querySelectorAll(ELEMENTS);
     this.windowWidth = window.innerWidth;

     if (!this.elements) {
       return false;
     }

     this.elements.forEach((el) => {
       el.addEventListener("click", this.toggle);
     });

     window.addEventListener('resize', this.recalculate);
   }

   recalculate = () => {
    if (window.innerWidth === this.windowWidth) {
      return false;
    }

    this.windowWidth = window.innerWidth

     const open = document.querySelectorAll('.js-Accordion .is-open');
     const sub = document.querySelectorAll('.js-Accordion .js-Accordion-sub');

    open.forEach((el) => {
      el.classList.remove(TOGGLE_CLASS)
    })

    sub.forEach((el) => {
      el.removeAttribute('style')
    })
   }

   recalculateParent = (sub, close = false) => {
     const parent = sub.closest('.faq__item-sub')
     const subHeight = sub.scrollHeight

     if(close){
      parent.style.height = parent.scrollHeight - subHeight + 'px'
     }else {
      parent.style.height = parent.scrollHeight + subHeight + 'px'
     }
   }

   toggle = (e) => {
     const el = e.currentTarget;
     const target = el.parentNode;
     const classes = target.classList
     const level = el.getAttribute('data-level')
     const sub = target.querySelector('.js-Accordion-sub')

     if(classes.contains(TOGGLE_CLASS)){
      classes.remove(TOGGLE_CLASS);

      if(sub){
        sub.style.height = 0
      }

      if(level == 2){
        this.recalculateParent(sub, true)
      }
     } else {
      if(sub){
        sub.style.height = sub.scrollHeight+'px'
      }

      classes.add(TOGGLE_CLASS);

      if(level == 2){
        this.recalculateParent(sub)
      }
     }

     e.preventDefault();
   };
 }

 new Accordion();
